type UrlChangeListener = (href: string) => void;

let detachUrlTracking: (() => void) | undefined;

export const startUrlTracking = (onUrlChange: UrlChangeListener): void => {
  if (detachUrlTracking) return;

  const emitCurrentHref = () => onUrlChange(window.location.href);
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function pushStateWithTracking(
    ...args: Parameters<typeof originalPushState>
  ) {
    originalPushState.apply(this, args);
    emitCurrentHref();
  };
  window.history.replaceState = function replaceStateWithTracking(
    ...args: Parameters<typeof originalReplaceState>
  ) {
    originalReplaceState.apply(this, args);
    emitCurrentHref();
  };
  window.addEventListener('popstate', emitCurrentHref);
  window.addEventListener('hashchange', emitCurrentHref);

  emitCurrentHref();

  detachUrlTracking = () => {
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
    window.removeEventListener('popstate', emitCurrentHref);
    window.removeEventListener('hashchange', emitCurrentHref);
  };
};

export const stopUrlTracking = (): void => {
  detachUrlTracking?.();
  detachUrlTracking = undefined;
};
